import React from "react";
import "../Styles/Quote.css";

const Quote = () => {
  return (
    <div>
      <div class="cp-wrapper">
        <figure class="review">
          <blockquote class="review__text">
            The gladdest moment in human life is a departure into unknown lands.
          </blockquote>
        </figure>
      </div>
    </div>
  );
};

export default Quote;
